import { u3202MergeParameterValues } from '../../u3202AiProvider/utils/u3202ParameterFormUtils';

function valuesEqual(a: unknown, b: unknown): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function u3203MergeDisplayValues(
  orgDefaults: Record<string, unknown>,
  overrides: Record<string, unknown> = {},
): Record<string, unknown> {
  return u3202MergeParameterValues(orgDefaults, overrides);
}

/** Extrait les overrides sparse à persister (diff vs defaults org). */
export function u3203ExtractSparseOverrides(
  orgDefaults: Record<string, unknown>,
  displayValues: Record<string, unknown>,
): Record<string, unknown> {
  const sparse: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(displayValues)) {
    if (value === undefined || value === null) continue;
    if (!valuesEqual(value, orgDefaults[key])) {
      sparse[key] = value;
    }
  }
  return sparse;
}

/** Clés dont la valeur affichée diffère du default org. */
export function u3203GetOverriddenKeys(
  orgDefaults: Record<string, unknown>,
  displayValues: Record<string, unknown>,
): string[] {
  return Object.keys(displayValues).filter((key) => !valuesEqual(displayValues[key], orgDefaults[key]));
}

/**
 * Clé de source de vérité pour resync onglet Paramètres (BL-0316).
 * N’inclut pas parameterDisplayValues (saisies utilisateur).
 */
export function u3203BuildParameterSourcesKey(params: {
  missionId: string | null | undefined;
  providerId: string | null | undefined;
  modelId: string | null | undefined;
  parameterOverrides: Record<string, unknown> | null | undefined;
  defaultParameters: Record<string, unknown> | null | undefined;
}): string {
  const overrideFingerprint = JSON.stringify(params.parameterOverrides ?? {});
  const defaultsFingerprint = JSON.stringify(params.defaultParameters ?? {});
  return `${params.missionId ?? 'new'}|${params.providerId ?? null}|${params.modelId ?? null}|${overrideFingerprint}|${defaultsFingerprint}`;
}

/** Display non initialisé après normalize/get ({} alors que le merge a des clés). */
export function u3203IsParameterDisplayUnseeded(
  display: Record<string, unknown> | null | undefined,
  merged: Record<string, unknown>,
): boolean {
  return Object.keys(display ?? {}).length === 0 && Object.keys(merged).length > 0;
}

/**
 * Décide si le panneau doit re-seed parameterDisplayValues.
 * false quand la source est déjà synchro et que le display n’est pas vide (conserve édition).
 */
export function u3203ShouldSeedParameterDisplay(
  alreadySyncedForSources: boolean,
  displayUnseeded: boolean,
): boolean {
  if (alreadySyncedForSources && !displayUnseeded) {
    return false;
  }
  return true;
}
